<template>
    <div  >
        <FoodCategoryComponent v-if="!showGroup" :lang="lang" @selectFood="selectFood" @error="onError"></FoodCategoryComponent>
        <FoodGroupComponent v-if="showGroup" :lang="lang" :idGroup="idGroup" @back="onBack" @error="onError"></FoodGroupComponent>
        <MessageComponent v-if="message!=''" :message="message" :messageType="messagetype"></MessageComponent>
    </div>
  
</template>

<script>
import FoodCategoryComponent from "@/components/FoodCategoryComponent.vue";
import FoodGroupComponent from "@/components/FoodGroupComponent.vue";
import MessageComponent from "@/components/MessageComponent.vue";
export default {
  name: "PageFoodByCategory",
  components: {
    FoodCategoryComponent,
    FoodGroupComponent,
    MessageComponent
  },
  data() {
    return {
       lang: this.$route.params.lang,
       idGroup: 0,
       showGroup : false,
       message: '',
       messagetype: 1
    };
  },
  methods:{
    selectFood(food){
        this.idGroup = food.idFood
        this.showGroup = true;
    },
    onBack() {
      this.showGroup = false;
    },
    onError(message) {
        this.message = message;
    }
  }
};
</script>

<style>
</style>